import { render, staticRenderFns } from "./ArtistsList.vue?vue&type=template&id=56971f51&scoped=true&"
import script from "./ArtistsList.vue?vue&type=script&lang=js&"
export * from "./ArtistsList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistsList.vue?vue&type=style&index=0&id=56971f51&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56971f51",
  null
  
)

export default component.exports